import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';

// Pages Components
import About from './Pages/About/About';
import Automation from './Pages/Automation/Automation';
import Blogs from './Pages/Blogs/Blogs';
import Career from './Pages/Carrer/Career';
import Jobs from './Pages/Carrer/Jobs';
import ChildSafety from './Pages/ChildSafety/ChildSafety';
import Contact from './Pages/Contact/Contact';
import EnergyEfficiency from './Pages/EnergyEfficiency/EnergyEfficiency';
import FabricShade from './Pages/FabricShade/FabricShade';
import FAQ from './Pages/FAQ/FAQ';
import FindDealer from './Pages/FindDealer/FindDealer';
import Home from './Pages/Home/Home';
import Innovation from './Pages/Innovation/Innovation';
import Inspiration from './Pages/Inspiration/Inspiration';
import LCP from './Pages/LightControlPrivacy/LCP';
import News from './Pages/News/News';
import OperatingSystems from './Pages/OperatingSystems/OperatingSystems';
import PhotosGallery from './Pages/PhotosGallery/PhotosGallery';
import Presence from './Pages/Presence/Presence';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import PrintedBlinds from './Pages/PrintedBlinds/PrintedBlinds';
import Products from './Pages/Products/Products';
import FilterFabricContent from './Pages/ProductsSubPage/FilterFabric/FilterFabricContent';
import SpecialSolutions from './Pages/SpecialSolution/SpecialSolutions';
import TermsConditions from './Pages/TermsConditions/TermsConditions';
import Trade from './Pages/Trade/Tade';
import VideosGallery from './Pages/VideosGallery/VideosGallery';
import WhyCallistus from './Pages/WhyCallistus/WhyCallistus';

// Import Video Page UI
import VideoPage_UI from './Pages/VideosGallery/VideoPageUI/VideoPageUI';

// Import Blog Post UI
import BlogPost_UI from './Pages/Blogs/BlogsPageUI/BlogsPageUI';

// Import Product page UI
import ProductPageUI from './Pages/ProductsSubPage/ProductPageUI/ProductPageUI';

// Import News Post UI
import NewsPost_UI from './Pages/News/NewsPost_UI/NewsPost_UI';

// Import Job Form UI
import JobApplyForm_UI from './Pages/Carrer/PageComponent/JobApplyForm_UI';

// Import Product OS UI
import Product_OS_UI from './Pages/OperatingSystems/Product_OS_UI/Product_OS_UI';

function App() {
  return (
    <Router>

      <ScrollToTop />

      <Routes>

        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/why-callistus" element={<WhyCallistus />} />
        <Route path="/presence" element={<Presence />} />
        <Route path="/products" element={<Products />} />
        <Route path="/special-solutions" element={<SpecialSolutions />} />
        <Route path="/gallery" element={<PhotosGallery />} />
        <Route path="/videos-gallery" element={<VideosGallery />} />
        <Route path="/inspiration" element={<Inspiration />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career/jobs" element={<Jobs />} />
        <Route path="/trade" element={<Trade />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/find-dealer" element={<FindDealer />} />

        {/* Resource / Footer Pages */}
        <Route path="/frequently-asked-questions" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/operating-systems" element={<OperatingSystems />} />
        <Route path="/fabric-shade" element={<FabricShade />} />
        <Route path="/light-control-privacy" element={<LCP />} />
        <Route path="/innovation" element={<Innovation />} />
        <Route path="/energy-efficiency" element={<EnergyEfficiency />} />
        <Route path="/news" element={<News />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/automation" element={<Automation />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/printed-blinds" element={<PrintedBlinds />} />

        {/* TODO: no Callistus equivalent yet for Dealer Login (footer resource link) */}

        {/* Dynamic URL for Products pages */}
        <Route path="/products/:productId" element={<ProductPageUI />} />

        {/* Dynamic URL for Products Fabric pages */}
        <Route path="/products/:productId/:ProductFabricId" element={<FilterFabricContent />} />

        {/* Dynamic URL for Blog Posts */}
        <Route path="/blog/:Blog_Posts" element={<BlogPost_UI />} />

        {/* Dynamic URL for News Posts */}
        <Route path="/news/:News_Post_Id" element={<NewsPost_UI />} />

        {/* Dynamic URL for Job Posts */}
        <Route path="/job/:JobPagesID" element={<JobApplyForm_UI />} />

        {/* Dynamic URL for Product OS Pages */}
        <Route path="/:ProductOS_PG_ID" element={<Product_OS_UI />} />

        {/* Dynamic URL for Video Pages */}
        <Route path="/videos/:Video_PageID" element={<VideoPage_UI />} />

        {/* Fallback URL If Page Not Found */}
        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
    </Router>
  );
}

export default App;